<template>
  <svg
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M80 140C113.136 140 140 113.189 140 80C140 46.811 113.018 20 80 20C46.8639 20 20 46.811 20 80C20 113.189 46.8639 140 80 140Z"
      fill="url(#paint0_linear_10083_73770)"
    />
    <path
      opacity="0.05"
      d="M27.4612 83.6362C26.5683 83.6362 25.854 82.9156 25.854 82.0149C25.854 50.3981 51.3902 24.6362 82.73 24.6362C87.4623 24.6362 92.1945 25.2668 96.6589 26.3477C97.4624 26.5278 97.9982 27.4286 97.8196 28.2393C97.641 29.05 96.7481 29.5904 95.9446 29.4103C91.6588 28.3294 87.1944 27.7889 82.73 27.7889C53.0866 27.7889 28.9791 52.1095 28.9791 82.0149C28.9791 82.9156 28.2648 83.6362 27.4612 83.6362Z"
      fill="url(#paint1_linear_10083_73770)"
    />
    <path
      opacity="0.05"
      d="M134.604 81.2487C135.494 81.3266 136.142 82.1068 136.064 83.0042C133.304 114.5 105.617 137.935 74.3967 135.2C69.6825 134.787 65.0234 133.745 60.6704 132.279C59.8856 132.029 59.4305 131.085 59.6792 130.293C59.9278 129.501 60.8645 129.041 61.6493 129.29C65.8244 130.741 70.2245 131.669 74.6718 132.059C104.202 134.646 130.34 112.523 132.951 82.7314C133.029 81.8341 133.804 81.1786 134.604 81.2487Z"
      fill="url(#paint2_linear_10083_73770)"
    />
    <path
      opacity="0.24"
      d="M42.3655 81.5769L43.1973 81.1607C43.4008 81.0588 43.4549 80.8822 43.3596 80.7406C43.2804 80.6228 43.1296 80.5832 42.9949 80.5383L42.3655 80.3283C41.2565 79.9121 40.4247 79.0797 40.0088 77.9699L39.5929 77.1375C39.4911 76.9338 39.3145 76.8796 39.173 76.9752C39.0554 77.0546 39.0159 77.2051 38.9711 77.3397L38.8285 77.7677C38.7836 77.9023 38.7304 78.0342 38.6626 78.1589C38.1104 79.1742 37.319 79.9361 36.4045 80.3283L35.6512 80.6514C35.5079 80.7128 35.3379 80.7751 35.3306 80.9308C35.3222 81.1093 35.5172 81.2023 35.677 81.2822L36.2658 81.5769C37.3749 81.993 38.2066 82.8254 38.7611 83.9352L39.177 84.7676C39.2788 84.9714 39.4554 85.0255 39.597 84.93C39.7146 84.8506 39.7541 84.7001 39.7989 84.5654L40.0088 83.9352C40.4247 82.8254 41.2565 81.993 42.3655 81.5769Z"
      fill="url(#paint3_linear_10083_73770)"
    />
    <path
      opacity="0.24"
      d="M108.529 44.5017L109 44.313C109.146 44.2544 109.326 44.1737 109.326 44.0162C109.326 43.8586 109.146 43.7779 109 43.7193L108.529 43.5306C107.697 43.2531 107.142 42.5595 106.726 41.7271L106.538 41.2551C106.479 41.1089 106.399 40.9294 106.241 40.9294C106.084 40.9294 106.003 41.1089 105.945 41.2551L105.756 41.7271C105.479 42.5595 104.786 43.1144 103.954 43.5306L103.538 43.8081C103.518 43.8179 103.5 43.8284 103.483 43.8395C103.164 44.0492 103.72 44.2972 104.075 44.4391L104.231 44.5017C105.063 44.7792 105.617 45.4728 106.033 46.3052L106.222 46.7772C106.28 46.9234 106.361 47.1029 106.519 47.1029C106.676 47.1029 106.757 46.9234 106.815 46.7772L106.908 46.5444C106.972 46.3854 107.013 46.2183 107.063 46.0546C107.284 45.3354 107.906 44.7508 108.529 44.5017Z"
      fill="url(#paint4_linear_10083_73770)"
    />
    <path
      opacity="0.24"
      d="M39.7619 100.901L41.0096 100.346C41.4255 100.207 41.4255 99.652 41.0096 99.5133L39.7619 98.9584C38.237 98.2647 36.9893 97.0162 36.2962 95.4901L35.7417 94.2416C35.603 93.8254 35.0485 93.8254 34.9099 94.2416L34.3554 95.4901C33.6622 97.0162 32.4146 98.2647 30.8897 98.9584L29.642 99.5133C29.2261 99.652 29.2261 100.207 29.642 100.346L30.8897 100.901C32.4146 101.594 33.6622 102.843 34.3554 104.369L34.9099 105.617C35.0485 106.034 35.603 106.034 35.7417 105.617L36.2962 104.369C36.8507 102.843 38.0984 101.594 39.7619 100.901Z"
      fill="url(#paint5_linear_10083_73770)"
    />
    <path
      opacity="0.24"
      d="M132.762 73.9006L134.01 73.3456C134.425 73.2069 134.425 72.652 134.01 72.5133L132.762 71.9584C131.237 71.2647 129.989 70.0162 129.296 68.4901L128.742 67.2416C128.603 66.8254 128.049 66.8254 127.91 67.2416L127.355 68.4901C126.662 70.0162 125.415 71.2647 123.89 71.9584L122.642 72.5133C122.226 72.652 122.226 73.2069 122.642 73.3456L123.89 73.9006C125.415 74.5942 126.662 75.8428 127.355 77.3688L127.91 78.6173C128.049 79.0335 128.603 79.0335 128.742 78.6173L129.296 77.3688C129.851 75.8428 131.098 74.5942 132.762 73.9006Z"
      fill="url(#paint6_linear_10083_73770)"
    />
    <path
      opacity="0.24"
      d="M57.3655 122.577L58.1973 122.161C58.4008 122.059 58.4549 121.882 58.3596 121.741C58.2804 121.623 58.1296 121.583 57.9949 121.538L57.3655 121.328C56.2565 120.912 55.4247 120.08 55.0088 118.97L54.5929 118.138C54.4911 117.934 54.3145 117.88 54.173 117.975C54.0554 118.055 54.0159 118.205 53.9711 118.34L53.8285 118.768C53.7836 118.902 53.7304 119.034 53.6626 119.159C53.1104 120.174 52.319 120.936 51.4045 121.328L50.6512 121.651C50.5079 121.713 50.3379 121.775 50.3306 121.931C50.3222 122.109 50.5172 122.202 50.677 122.282L51.2658 122.577C52.3749 122.993 53.2066 123.825 53.7611 124.935L54.177 125.768C54.2788 125.971 54.4554 126.026 54.597 125.93C54.7146 125.851 54.7541 125.7 54.7989 125.565L55.0088 124.935C55.4247 123.825 56.2565 122.993 57.3655 122.577Z"
      fill="url(#paint7_linear_10083_73770)"
    />
    <g filter="url(#filter0_d_10083_73770)">
      <path
        d="M95.5384 55.9354L75.1179 52.6804L75.7603 48.6333C76.3546 44.8898 79.96 42.3524 83.6882 42.9467L90.4051 44.0173C94.234 44.6277 96.759 48.246 96.1808 51.8883L95.5384 55.9354Z"
        fill="#047CFF"
      />
      <path
        d="M107.752 70.227L103.412 63.7259L109.188 59.8749C110.006 59.2791 111.098 59.5569 111.591 60.3615L114.015 63.9638C114.608 64.7844 114.33 65.8813 113.529 66.3759L107.752 70.227Z"
        fill="#047CFF"
      />
      <path
        d="M58.2778 62.3409L64.4168 57.5102L60.1175 52.053C59.5246 51.2323 58.4002 51.1568 57.6832 51.7687L54.2632 54.4394C53.4454 55.0352 53.3695 56.1642 53.9785 56.8837L58.2778 62.3409Z"
        fill="#047CFF"
      />
      <path
        d="M75.5317 113.744C92.8386 116.503 109.083 104.787 111.815 87.5765C114.547 70.366 102.732 54.1778 85.4252 51.4191C68.1184 48.6603 51.8736 60.3758 49.1416 77.5863C46.4096 94.7968 58.2248 110.985 75.5317 113.744Z"
        fill="#7FBAFE"
      />
      <path
        d="M76.2706 109.09C90.9619 111.432 104.756 101.462 107.08 86.8217C109.404 72.1816 99.3779 58.415 84.6865 56.0732C69.9951 53.7314 56.2015 63.7012 53.8775 78.3413C51.5535 92.9814 61.5792 106.748 76.2706 109.09Z"
        fill="white"
        stroke="#7FBAFE"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        opacity="0.2"
        d="M106.069 86.7127C105.992 87.2004 105.93 87.5906 105.755 88.0628C107.229 74.3963 97.7648 61.9866 84.092 59.8072C70.4191 57.6277 57.5642 66.5798 54.6671 79.8193C54.7446 79.3316 54.7095 78.926 54.7869 78.4383C57.0321 64.2947 70.3833 54.7217 84.444 56.963C98.6833 59.3328 108.314 72.5691 106.069 86.7127Z"
        fill="#7FBAFE"
      />
      <path
        opacity="0.24"
        d="M101.84 85.9865C101.712 86.7959 101.499 87.4881 101.386 88.1964C101.028 89.7991 99.0702 90.4206 97.6712 89.4714L87.4182 81.8204C86.6764 81.2872 86.301 80.3975 86.4456 79.4869L88.5496 66.2328C88.8226 64.5128 90.7283 63.5717 92.228 64.5369C99.1544 69.0643 103.222 77.2853 101.84 85.9865Z"
        fill="url(#paint8_linear_10083_73770)"
      />
      <path
        d="M82.3077 80.8256C82.2302 81.3138 81.7717 81.6464 81.2836 81.5686L80.1359 81.3857C79.6452 81.3075 79.3119 80.8443 79.3935 80.3541L81.434 68.1068C81.5625 67.2974 82.3642 66.8028 83.0695 66.9152C83.8756 67.0437 84.3678 67.8483 84.2553 68.5566L82.3077 80.8256Z"
        fill="#7FBAFE"
      />
      <path
        d="M78.4522 82.9842C78.6128 81.9725 79.5634 81.1904 80.6718 81.3671C81.7802 81.5437 82.357 82.4656 82.1964 83.4773C82.0358 84.4891 81.0852 85.2712 79.9768 85.0945C78.9692 84.9339 78.2755 84.0972 78.4522 82.9842Z"
        fill="#989FB0"
      />
      <path
        d="M97.6678 96.0013C97.6116 96.0027 97.5405 96.0112 97.4859 96.0245C97.4137 96.0421 97.3212 96.0415 97.2372 96.035C97.111 96.0252 96.9927 95.9726 96.8898 95.8986L79.9837 83.7475C79.7982 83.6142 79.7457 83.2946 79.8785 83.1083C80.0114 82.922 80.3298 82.869 80.5152 83.0023L97.5778 95.2659C97.7227 95.3701 97.7865 95.588 97.744 95.7672C97.7231 95.8554 97.7584 95.9991 97.6678 96.0013Z"
        fill="#7FBAFE"
      />
      <path
        d="M77.0414 82.7595C77.3145 81.0395 78.95 79.8479 80.7798 80.0358C82.6095 80.2238 83.6785 81.9502 83.4055 83.6702C83.1324 85.3902 81.4969 86.5818 79.6672 86.3939C77.9221 86.3232 76.7523 84.5807 77.0414 82.7595Z"
        fill="#7FBAFE"
      />
      <path
        opacity="0.16"
        d="M78.3458 101.225L76.6329 100.952C76.3306 100.904 75.9962 101.058 75.932 101.463L75.2574 105.712C75.2092 106.016 75.3626 106.351 75.7656 106.416L77.4785 106.689C77.7808 106.737 78.1152 106.583 78.1795 106.178L78.778 102.408C78.8284 102.09 78.866 101.745 78.6931 101.474C78.6104 101.345 78.4967 101.249 78.3458 101.225Z"
        fill="url(#paint9_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M85.1715 58.225L83.4586 57.952C83.1563 57.9038 82.8219 58.0579 82.7576 58.4627L82.0831 62.7121C82.0349 63.0156 82.1882 63.3512 82.5913 63.4155L84.3042 63.6885C84.6065 63.7367 84.9409 63.5826 85.0052 63.1778L85.6037 59.4074C85.6541 59.0902 85.6917 58.745 85.5188 58.4742C85.4361 58.3447 85.3224 58.249 85.1715 58.225Z"
        fill="url(#paint10_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M61.7399 77.6234L57.5079 76.9488C57.2056 76.9006 56.8712 77.0548 56.807 77.4595L56.5339 79.1795C56.4857 79.483 56.6391 79.8187 57.0421 79.8829L61.2741 80.5575C61.5764 80.6057 61.9108 80.4515 61.975 80.0468L62.2481 78.3268C62.3123 77.9221 62.0422 77.6715 61.7399 77.6234Z"
        fill="url(#paint11_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M85.5194 106.218C86.2913 106.054 86.7846 105.293 86.6211 104.518C86.4576 103.743 85.6993 103.248 84.9274 103.413C84.1555 103.577 83.6623 104.338 83.8258 105.113C83.9893 105.888 84.7475 106.383 85.5194 106.218Z"
        fill="url(#paint12_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M95.0989 101.858C95.7294 101.381 95.8562 100.482 95.3821 99.8494C94.908 99.2166 94.0125 99.0898 93.3819 99.5663C92.7514 100.043 92.6246 100.942 93.0987 101.575C93.5728 102.208 94.4683 102.334 95.0989 101.858Z"
        fill="url(#paint13_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M58.32 87.0759C59.0973 86.9402 59.6181 86.1977 59.4832 85.4174C59.3482 84.6371 58.6087 84.1145 57.8313 84.2501C57.054 84.3858 56.5332 85.1283 56.6682 85.9086C56.8031 86.6889 57.5427 87.2115 58.32 87.0759Z"
        fill="url(#paint14_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M62.761 96.2593C63.4086 95.8065 63.5683 94.9125 63.1176 94.2626C62.667 93.6127 61.7767 93.453 61.1291 93.9059C60.4815 94.3587 60.3219 95.2527 60.7725 95.9026C61.2232 96.5525 62.1135 96.7122 62.761 96.2593Z"
        fill="url(#paint15_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M70.457 102.345C70.8536 101.66 70.622 100.783 69.9399 100.385C69.2577 99.9878 68.3832 100.221 67.9866 100.906C67.59 101.591 67.8216 102.468 68.5038 102.866C69.186 103.263 70.0605 103.03 70.457 102.345Z"
        fill="url(#paint16_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M77.2433 61.5484C78.022 61.4202 78.5498 60.6826 78.4222 59.901C78.2947 59.1194 77.56 58.5897 76.7814 58.7179C76.0028 58.8461 75.475 59.5837 75.6025 60.3653C75.7301 61.1469 76.4647 61.6766 77.2433 61.5484Z"
        fill="url(#paint17_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M68.4426 65.0193C69.0944 64.5726 69.2624 63.6803 68.818 63.0261C68.3735 62.372 67.4848 62.2038 66.833 62.6505C66.1812 63.0971 66.0131 63.9895 66.4576 64.6436C66.9021 65.2977 67.7908 65.4659 68.4426 65.0193Z"
        fill="url(#paint18_linear_10083_73770)"
      />
      <path
        opacity="0.16"
        d="M61.9186 71.8229C62.2928 71.1903 62.0855 70.3733 61.4557 69.9981C60.8259 69.6229 60.012 69.8315 59.6379 70.4641C59.2637 71.0967 59.471 71.9137 60.1008 72.2889C60.7307 72.6641 61.5445 72.4555 61.9186 71.8229Z"
        fill="url(#paint19_linear_10083_73770)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10083_73770"
        x="26.749"
        y="32.8604"
        width="109.584"
        height="115.286"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="11" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0156863 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_73770"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_73770"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_73770"
        x1="19.9981"
        y1="139.999"
        x2="139.999"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_73770"
        x1="25.8529"
        y1="83.6359"
        x2="83.7023"
        y2="13.0397"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_73770"
        x1="136.206"
        y1="81.3894"
        x2="72.4159"
        y2="146.667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_73770"
        x1="35.33"
        y1="84.9757"
        x2="43.3762"
        y2="76.9005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_73770"
        x1="103.33"
        y1="47.1028"
        x2="109.501"
        y2="41.1097"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10083_73770"
        x1="29.3299"
        y1="105.929"
        x2="41.33"
        y2="93.9379"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10083_73770"
        x1="122.33"
        y1="78.9294"
        x2="134.33"
        y2="66.9379"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10083_73770"
        x1="50.33"
        y1="125.976"
        x2="58.3762"
        y2="117.901"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_10083_73770"
        x1="85.138"
        y1="87.7226"
        x2="109.606"
        y2="76.4254"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_10083_73770"
        x1="75.161"
        y1="106.319"
        x2="80.0904"
        y2="104.611"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_10083_73770"
        x1="81.9867"
        y1="63.3191"
        x2="86.916"
        y2="61.6108"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_10083_73770"
        x1="56.4375"
        y1="79.7865"
        x2="59.6118"
        y2="75.6319"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_10083_73770"
        x1="84.1217"
        y1="106.516"
        x2="86.3366"
        y2="103.123"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_10083_73770"
        x1="93.9571"
        y1="102.721"
        x2="94.5256"
        y2="98.7039"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_10083_73770"
        x1="56.9125"
        y1="87.3215"
        x2="59.2505"
        y2="84.0128"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_10083_73770"
        x1="61.5884"
        y1="97.0793"
        x2="62.3048"
        y2="93.0864"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_10083_73770"
        x1="69.7389"
        y1="103.585"
        x2="68.6947"
        y2="99.6683"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_10083_73770"
        x1="75.8334"
        y1="61.7806"
        x2="78.203"
        y2="58.4943"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_10083_73770"
        x1="67.2623"
        y1="65.828"
        x2="68.0166"
        y2="61.8424"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_10083_73770"
        x1="61.2412"
        y1="72.9683"
        x2="60.3062"
        y2="69.3211"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
